import React, { useEffect, useState } from "react";
import MainContentWrapper from "../../Components/MainContentWrapper";
import DashBoardCard from "../../features/HomePage/SubComponents/DashBoardCard/DashBoardCard";
import { getTelecallerDashboardOverViewData } from "../../apis/BhuMeetTeams/Telecaller/dashboard";
import { getRequestQueue, reShuffleRequestQueue } from "../../apis/BhuMeetTeams/Telecaller/requestqueue";
import TableView from "../../ReusableComponents/TableView/TableView";
import Loading from "../../ReusableFunctions/Loader";
import { useNavigate } from "react-router";
import { PDRL_SUCCESS_ENGI_ROUTES } from "../../routes";
import { useSelector } from "react-redux";
import { fi } from "date-fns/locale";
import { Button } from "../../Components/Helper";
import Filter from "../../assets/filter.svg";
import TeleDashboardFilter from "./teleCallerFilter";
import Popup from "../../ReusableFunctions/Popup";
import useEvent from "./eventListener";
import { SERVER_URLS } from "../../appConstants";
import NotificationSnackbar from "./Notification";
import search from '../../assets/search.svg'

const InvoicesStatCard = ({
  title,
  statNumber,
  isSelected,
  onClick,
  isDisabled,
  isArray
}) => {
  return (
    <DashBoardCard
      isDisabled={isDisabled}
      title={title}
      data={statNumber}
      onClick={onClick}
      backGround={isSelected ? "green" : undefined}
      isArray={isArray}
    />
  );
};

const InvoiceStats = ({ invoicesStats, filters, changeStatusFilter, ArrayData, userDetails }) => {
  return (
    <>
      {filters &&
        <div style={{ display: "flex", columnGap: "2%", marginBottom: "10px" }}>


          <InvoicesStatCard
            title={`All Request`}
            statNumber={invoicesStats?.total}
            isSelected={filters.Status === ""}
            isDisabled={userDetails.bhumeet_role == 'Telecaller'}
            onClick={() =>
              changeStatusFilter({
                Status: "",
                Query: "",
                count: invoicesStats?.total,
                currentPage: 1
              })
            }
          />



          <InvoicesStatCard
            title={`Open`}
            statNumber={invoicesStats?.open_count}
            isSelected={filters.Status === "open" && userDetails.bhumeet_role != 'Telecaller'}
            isDisabled={userDetails.bhumeet_role == 'Telecaller'}
            onClick={() =>
              changeStatusFilter({
                Status: "open",
                Query: "open",
                count: invoicesStats?.open_count,
                currentPage: 1
              })
            }
          />



          <InvoicesStatCard
            title={`Close`}
            statNumber={invoicesStats?.close_count}
            isSelected={filters.Status === "close"}
            isDisabled={userDetails.bhumeet_role == 'Telecaller'}
            onClick={() =>
              changeStatusFilter({
                Status: "close",
                Query: "close",
                count: invoicesStats?.close_count,
                currentPage: 1
              })
            }
            isArray={ArrayData && filters.Status == 'close' ? ArrayData : null}
          />


        </div>}
    </>

  );
};

export const TeleCallerDashBoard = () => {
  const userDetails = useSelector(state => state.user?.user)

  const { data, error } = useEvent(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/telecaller/requestQueue/event?userID=${userDetails.id}`);

  useEffect(() => {
    console.log("Data",data)
    // console.log("Error",error)

    
    if(error == null){
      console.log("Error",error)
      getOverViewData()
    getTelecallers();
      setRefresh((prev) => prev + 1);
    }
    
  }, [data])

  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  // const [PageNumber, setPageNumber] = useState(1);
  const [openFilter, setOpenFilter] = useState(false);

  const [overviewData, setOverviewData] = useState({});
  const [RequestQueueData, setRequestQueueData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [callHistoryOverview, setCallHistoryOverview] = useState([]);
  const [refresh, setRefresh] = useState(data);

  const [filter, setFilter] = useState(() => {
    const getFilters = localStorage.getItem("telecallerFilter");
    return getFilters ? JSON.parse(getFilters) : {
      fromDate: null,
      toDate: null,
      Status: "open",
      pageSize: 15,
      count: 0,
      currentPage: 1,
      Substatus: [],
      selectedCaller: "",
      searchString: ""
    };
  });



  const getOverViewData = () => {
    if (filter) {

      getTelecallerDashboardOverViewData(userDetails.bhumeet_role == 'Admin' ? "" : userDetails.id, JSON.stringify(filter)).then((res) => {
        setOverviewData(res.overviewData);

        let getOverData = JSON.parse(localStorage.getItem('Telecaller_overviewData'))
        if (getOverData?.total != res.overviewData.total) {
          // setRefresh((prev) => prev + 1);
        }
        localStorage.setItem('Telecaller_overviewData', JSON.stringify(res.overviewData))
        // setFilter({...filter,count:res.overviewData.total})
        if (filter.Status) {
          const callHistoryoutput = Object.entries(res.callHistoryOverviewData).map(([status, count]) => ({
            status,
            count: Number(count)
          }));
          
          // console.log(output)
          setCallHistoryOverview(callHistoryoutput);
        }

      });
    }

  }

  useEffect(() => {


    getOverViewData()
    getTelecallers();
    // setCurrentPage(1)

    localStorage.setItem('telecallerFilter', JSON.stringify(filter))
    // console.log(filters)


  }, [filter]);


  useEffect(()=>{
    
    console.log("Refresh",refresh)
  },[refresh])

  useEffect(() => {
    setCurrentPage(1)
  }, [filter.Status])

  const getTelecallers = () => {
    // console.log(filter)
    if (userDetails && filter != null) {
      setLoading(true);
      getRequestQueue(
        JSON.stringify(filter),
        userDetails.bhumeet_role == 'Admin' ? "" : userDetails.id,
        filter.currentPage,
        filter.pageSize || 15
      ).then((res) => {
        // console.log(res);

        setRequestQueueData(res);
        setLoading(false);
      });
    }
  };

  const paginationCount = () => {
    // console.log(filter)
    if (filter.Status == '') {
      return Number(overviewData.total)
    } else if (filter.Status == 'open') {
      return Number(overviewData.open_count)
    } else {
      return Number(overviewData.close_count)

    }
  }

  const reshuffle = () => {
    reShuffleRequestQueue().then(res => {
      // console.log(res)
      return Popup.alert("SUCCESS", "Successfully Shuffled all request", "SUCCESS")
    })
  }

  return (
    <MainContentWrapper header={"TeleCaller Dashboard"}

      rightContent={<>
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "5px"
        }}>


          {userDetails.bhumeet_role == 'Admin' &&
            <Button
              text={"Reshuffle"}
              onClick={() => {
                reshuffle()
              }}
              style={{ width: "130px", height: "38px", fontSize: "15px", marginRight: "10px" }}

            />
          }
          {refresh > 2 ? <NotificationSnackbar key={refresh} /> : null}
          <Button
            innerClassName={"filter-btn-inner"}
            iconStyle={{ width: "18px", marginRight: "10px" }}
            text={"Filter"}
            icon={Filter}
            className={"filter-btn"}
            onClick={() => {
              setOpenFilter(true)
            }}

          />
        </div>


      </>


      }



    >


      {openFilter &&
        <TeleDashboardFilter
          filter={filter}
          onFilterChange={(filter) => {
            // console.log(filter)
            setCurrentPage(1)
            setOpenFilter(false)
            setFilter(filter)

          }}
          onClose={() => setOpenFilter(false)}
          open={openFilter}
        />
      }
      <InvoiceStats
        invoicesStats={overviewData}
        filters={filter}
        userDetails={userDetails}
        // ArrayData = {callHistoryOverview}
        changeStatusFilter={(statusFiler) => {
          // console.log(statusFiler);
          setFilter({
            ...filter,
            count: statusFiler.count,
            Status: statusFiler.Status,
            currentPage: statusFiler.currentPage
          });
        }}
      />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {userDetails.bhumeet_role == 'Admin' &&
          <div style={{ position: "relative", height: "40px", width: "32%", marginBottom: "5px" }}>
            <img src={search} alt='search icon' style={{ position: 'absolute', left: "20px", top: "10px" }} />
            <input value={filter.searchString} onChange={(e) => {
              console.log(e.target.value)
              if (Number(e.target.value) || e.target.value == '') {

                setFilter((prev) => ({ ...prev, searchString: e.target.value, currentPage: 1 }))
              }
            }}
              placeholder='Search queue by request no...'
              style={{ width: "100%", height: '100%', borderRadius: "4px", border: "1px solid #BFC8D9", padding: "10px 10px 10px 60px", fontSize: "12px" }} />
          </div>
        }

        <div>
          {
            (callHistoryOverview && filter.Status == 'close' || callHistoryOverview && userDetails.bhumeet_role == 'Telecaller') &&
            <>
              <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "inherit", width: "31%", marginLeft:userDetails.bhumeet_role == "Telecaller" ? "212%":"", marginBottom: "10px", gap: "20px" }}>
                {
                  callHistoryOverview.map((item, index) => {

                    return (
                      <>
                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "11px", height: "90%" }}>
                          <div style={{ color: "blue", whiteSpace: "nowrap" }} className="dashboard-card-parent-inner1 dashboard-cards-heading" >{item.status.replace("_", " ")
                            .split(" ")
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(" ").replace("Coudnt", "Couldn't")}
                          </div>
                          <div style={{ marginLeft: '50%', fontSize: "medium" }} className="dashboard-card-parent-inner2 dashboard-cards-main-data"> {item || item.count === 0 ? item.count : ''}</div>
                        </div>
                      </>
                    )
                  })
                }
              </div>
            </>
          }

        </div>


      </div>


      <TableView
        onStateChange={async (changedState) => {
          const { pageNumber } = changedState;
          // console.log(changedState);
          setCurrentPage(() => pageNumber);
          setFilter({ ...filter, currentPage: pageNumber })

        }}
        onClickRow={(row) => {

          if ((RequestQueueData[0].queueid == row.queueid && filter.currentPage == 1) || userDetails.bhumeet_role == 'Admin') {
            navigate(`${PDRL_SUCCESS_ENGI_ROUTES.REQUESTDETAILS}`, {
              state: { request: { type: "Spraying service", id: row.reqid, show: true, Data: row } },
            });
          } else {
            return Popup.alert("WARNING", "Please select the first row to view the request details", "ERROR")
          }

        }}
        isLoading={loading}
        tableContainerHeight={"75%"}
        loaderHeight={"500px"}
        columns={[
          { Header: "Request Number", accessor: "req_number", width: "15%" },
          ...(userDetails.bhumeet_role === "Admin"
            ? [{ Header: "Assignee", accessor: "name", width: "15%" }]
            : []),
          { Header: "Note", accessor: "note" },
          { Header: "Status", accessor: "status" },
          { Header: "Date", accessor: "dateadded", isDate: true },
        ]}
        data={RequestQueueData}
        pageNumber={filter.currentPage ?? 1}
        pageSize={15}
        count={paginationCount()}

      // activities={{ onClickDelete: (coupon) => Popup.alert("WARNING", "Are you sure , you want to delete this coupon?", "WARNING", () => deleteCoupon(coupon)), onClickEdit: onEdit, canEdit: true }}
      />
    </MainContentWrapper>
  );
};
